<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ded"></a></p>
<div class="ctag1"><i>For Emily and Claudia,</i> <br/><i>who really did get me through.</i> <br/><i>With much love.</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vinc_9781590208007_oeb_ded_r1.vue?4f040250